<!--
  创建时间：2024/8/21 18:31
  创建人：toyehuang
  文件描述：ImageNews
-->

<template>
  <div class="image-news mt-30">
    <block-head-line title="重点推介" :more-btn-url="moreBtnUrl" />
    <el-carousel height="200px" :interval="15000" arrow="never" class="mt-20">
      <el-carousel-item v-for="item in dataList" :key="item.id">
        <div class="image-news-item">
          <Link :to="item.url" class="img-link" target="_blank">
            <img :alt="item.title" :src="item.adImage" class="link-item">
          </Link>
          <p class="image-news-title pl-10">
            <Link :to="item.url" target="_blank" class="title-link text-cut">{{ item.title }}</Link>
          </p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import BlockHeadLine from "@/views/home/components/BlockHeadLine.vue";
import adApi from "@/api/ad";
import { AD_CODE } from "@/utils/constant";

export default {
  name: "ImageNews",
  components: { BlockHeadLine, Link },
  props: {
  },
  data() {
    return {
      dataList: []
    };
  },
  // 监听属性 类似于data概念
  computed: {
    moreBtnUrl() {
      return "/ad/list/" + AD_CODE.AD_IMPORTANT;
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.loadListData()
  },
  // 方法集合
  methods: {
    loadListData() {
      adApi.page({ pageNo: 1, pageSize: 5, type: AD_CODE.AD_IMPORTANT }).then((res) => {
        this.dataList = res.data.list;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.image-news{
  width: 100%;
  .image-news-item{
    width: 100%;
    height: 100%;
    position: relative;
    .img-link{
      display: block;
      width: 100%;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &:hover{
      img{
        opacity: 0.8;
      }
    }
    .image-news-title{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      height: 45px;
      line-height: 45px;
      background-color: rgba(0,0,0,0.4);
      padding-right: 80px;
      font-size: 14px;
      .title-link{
        color: #fff;
        display: block;
      }
    }
  }
  ::v-deep{
    .el-carousel__indicators--horizontal{
      transform: translateX(-100%);
      left: 100%;
      right: 0;
			width: 70px;
      .el-carousel__indicator--horizontal{
        .el-carousel__button{
          width: 6px;
          height: 6px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
